// extracted by mini-css-extract-plugin
export default {"info":"ContactInformation_info__yXye1","nowrap":"ContactInformation_nowrap__E23yz"};